export const FRIENDS_MODAL_TABS = {
  friends: 'friends',
  add: 'add',
  requests: 'requests',
};
